/**
 *
 * LiveModeCourse
 *
 */
import { mapGetters, mapActions } from 'vuex';
import $ from 'jquery';
//import Swal from 'sweetalert2';

import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import Player from '@/components/Player.vue';

//import { IDENTITY_PAGE } from '@/constants/routes';
export default {
  name: 'LiveModeCourse',

  components: {
    WayFindBar,
    ToolBar,
    Footer,
    Spinner,
    Player,
  },

  data() {
    return {
      promiseGetPureCourse: null,
      chatroom: null,
      liveSdk: null,
      titleTxt: '',
      isFullscreen: false,
      isLiveBackFullscreen: false,
      liveBackTitleTxt: '',
      currentVideo: {},
      isShowPlayer: false,
    };
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    ...mapGetters({
      isRequest: 'LiveModeCourse/isRequest',
      Course: 'LiveModeCourse/Course',
      Token: 'LiveModeCourse/Token',
    }),

    CourseId: function () {
      return this.$route.params.courseId;
    },
  },

  mounted() {
    window.scrollTo(0, 0);
    this._liveModeCourseMounted();
  },

  created() {
    this.promiseGetLiveCourse = this.$store.dispatch('LiveModeCourse/getLiveCourse', this.CourseId);
  },

  beforeDestroy() {
    //
  },

  methods: {
    ...mapActions({
      getLiveToken: 'LiveModeCourse/getLiveToken',
    }),

    goBack() {
      this.$router.go(-1);
    },

    async _liveModeCourseMounted() {
      await this.promiseGetLiveCourse;
    },

    async openLiveModal(channelId, sign, timestamp, titleTxt) {
      window.open(
        `https://live.polyv.cn/watch/${channelId}`,
        '_blank'
      );
      // window.location.href=
      // const _this = this;
      // await this.getLiveToken(channelId);
      // $('#liveModal').modal('show');
      // this.titleTxt = titleTxt;
      // this.chatroom = new PolyvChatRoom({
      //   roomId: channelId,
      //   userId: _this.userInfo.studentId,
      //   nick: _this.userInfo.nickname,
      //   pic: 'http://livestatic.videocc.net/assets/wimages/missing_face.png',
      //   token: _this.Token.token,
      //   mediaChannelKey: _this.Token.mediaChannelKey,
      //   version: '2.0',
      //   container: '#live_class_room',
      //   width: 300,
      //   height: '100%',
      //   userType: '',
      //   roomMessage: function (data) {
      //   }
      // });

      // this.liveSdk = new PolyvLiveSdk({
      //   channelId: channelId,
      //   sign: sign, // 频道验证签名
      //   timestamp: timestamp, // 毫秒级时间戳
      //   appId: 'f23l872ee4', // polyv 后台的appId
      //   user: {
      //     userId: _this.userInfo.studentId,
      //     userName: _this.userInfo.nickname,
      //     pic: "//livestatic.videocc.net/assets/wimages/missing_face.png",
      //   },
      // });

      // this.liveSdk.on(PolyvLiveSdk.EVENTS.CHANNEL_DATA_INIT, (event, data) => {
      //   _this.liveSdk.setupPlayer({
      //     pptEl: "#ppt",
      //     el: "#live_player",
      //     type: "auto",
      //     autoplay: true, // 设置自动播放
      //   });
      // });
    },

    resizeModal() {
      this.isFullscreen = !this.isFullscreen;
    },
    resizeLiveBackModal() {
      this.isLiveBackFullscreen = !this.isLiveBackFullscreen;
    },

    closeLivePlayer() {
      $(`#liveModal`).modal('hide');
      const _this = this;
      _this.chatroom.chat.socket.close();
      _this.chatroom = null;
      $('#live_class_room').empty();
      _this.liveSdk = null;
      $('#live_player').empty();
      $('#ppt').empty();
    },

    async openPlayer(v) {
      const obj = {
        courseId: v.courseId,
        bookId: v.bookId,
        bulletName: v.liveName,
        bulletId: v.bulletId,
        videoId: v.videoId,
        speed1: v.vpath,
        speed1Dot3: v.vpath_1_3,
        speed1Dot5: v.vpath_1_5,
        speed2: v.vpath_2,
        vpathFree: v.vpathFree,
        freeMode: v.freeMode,
        isNew: true,
        isLatest: true,
        endOfReading: true,
        collected: false,
        bulletStatus: v.bulletStatus,
        lastProgress: v.lastProgress,
        videoSpeed: v.videoSpeed,
        haveNote: false,
        canAccess: v.canAccess,
        showPolyvSpeed: false,
      };
      this.currentVideo = obj;
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
    },

    // bulletName: v.bulletName,
    // bulletId: v.bulletId,
    // videoId: v.videoId,
    // speed1: v.vpath,
    // speed1Dot3: v.vpath_1_3,
    // speed1Dot5: v.vpath_1_5,
    // speed2: v.vpath_2,
    // isLatest: i === arr.length - 1,
    // endOfReading: v.endOfReading ? true : false,
    // collected: v.collected ? true : false,
  },
};
